import styled from 'styled-components';

const StyledAppNavbar = styled.div`
    img.brand-logo {
        width: 117px;
        height: 34px;
    }
`;

export default StyledAppNavbar;
